import { render, staticRenderFns } from "./sampleDetails.vue?vue&type=template&id=87bda390&"
import script from "./sampleDetails.vue?vue&type=script&lang=js&"
export * from "./sampleDetails.vue?vue&type=script&lang=js&"
import style0 from "./sampleDetails.vue?vue&type=style&index=0&id=87bda390&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports